import { Link } from "react-router-dom";
import { Avatar } from "../avatar";
import { Logo } from "../logo";
import { useUser } from "../../hooks/User";
import "./header.scss";

export const PrivateHeader = () => {

  const { name, imageUrl } = useUser().getDataAll();

  return (
    <header data-testid="header" className="header">
      <div className="left-col">
        <Link to={"/"} className={"link-homepage"}>
          <Logo />
        </Link>
      </div>
      
      <div className="right-col">
        <Link to={"/profile"} className={"link-username"}>
          <span className="user-fullname">{name}</span>
          <Avatar url={imageUrl} testId={"header-user"} />
        </Link>
      </div>
    </header>
  );
};
